import React from "react"
import {
  Tooltip as TooltipRoot,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/Tooltip"

interface TooltipProps {
  tip: string | undefined
  children: React.ReactNode
  // Pass asChild when children is a single React element that should become
  // the trigger directly (avoids an extra wrapper affecting layout).
  asChild?: boolean
}

const Tooltip = ({ tip, children, asChild = false }: TooltipProps) => {
  if (!tip) return <>{children}</>
  return (
    <TooltipRoot>
      <TooltipTrigger asChild>
        {asChild ? (children as React.ReactElement) : <span>{children}</span>}
      </TooltipTrigger>
      <TooltipContent>{tip}</TooltipContent>
    </TooltipRoot>
  )
}

export default Tooltip
